import React from "react";
import {
  InfoOutlined,
  AttachMoneyOutlined,
  BusinessOutlined,
  TransferWithinAStationOutlined,
  PersonOutlined,
  NoteOutlined,
  AirplaneTicketOutlined,
  MedicalInformationOutlined,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { useCodTransferDetailContext } from "contexts/PaymentContexts/CodTransferContext";
import { localizeDateTimeShort } from "utils/dateFormats";
import OpenInNewTab from "components/Shared/OpenInNewTab";
import { useAuth } from "hooks";

const CodTransferBasicDetail = () => {
  const { isVendor } = useAuth();

  const { CodTransferDetail, loadingCodTransferDetail } =
    useCodTransferDetailContext();

  return !loadingCodTransferDetail ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <MedicalInformationOutlined color="primary" />}
            title="ID"
            subtitle={CodTransferDetail?.codTransferId || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <AirplaneTicketOutlined color="primary" />}
            title="Ticket"
            subtitle={
              CodTransferDetail?.ticket?._id ? (
                isVendor ? (
                  <OpenInNewTab
                    label={CodTransferDetail?.ticket?.ticketNo}
                    link={`/app/vendor/ticket/${CodTransferDetail?.ticket?._id}/detail`}
                    disableIcon
                  />
                ) : (
                  <OpenInNewTab
                    label={CodTransferDetail?.ticket?.ticketNo}
                    link={`/app/crm/ticket/${CodTransferDetail?.ticket?._id}/detail`}
                    disableIcon
                  />
                )
              ) : (
                "N/A"
              )
            }
          />
        </Grid>

        {!isVendor && (
          <Grid item xs={3}>
            <InformationTile
              icon={() => <PersonOutlined color="primary" />}
              title="Vendor Profile"
              subtitle={
                CodTransferDetail?.vendor?.vendor?._id ? (
                  isVendor ? (
                    <span>{CodTransferDetail?.vendor?.vendor?.name}</span>
                  ) : (
                    <OpenInNewTab
                      label={CodTransferDetail?.vendor?.vendor?.name}
                      link={`/app/crm/vendor-profile/${CodTransferDetail?.vendor?.vendor?._id}/detail`}
                      disableIcon
                    />
                  )
                ) : (
                  "N/A"
                )
              }
            />
          </Grid>
        )}

        <Grid item xs={3}>
          <InformationTile
            icon={() => <PersonOutlined color="primary" />}
            title="Receiver"
            subtitle={CodTransferDetail?.receiver || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <AttachMoneyOutlined color="primary" />}
            title="Actual Amount"
            subtitle={` Rs. ${CodTransferDetail?.actualAmount ?? "N/A"}`}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <AttachMoneyOutlined color="primary" />}
            title="Service Amount (1%)"
            subtitle={` Rs. ${CodTransferDetail?.feeAmount ?? "N/A"}`}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <AttachMoneyOutlined color="primary" />}
            title="Paid Amount (Transfer)"
            subtitle={` Rs. ${CodTransferDetail?.transferAmount ?? "N/A"}`}
          />
        </Grid>
        {CodTransferDetail?.bankName?.name && (
          <Grid item xs={3}>
            <InformationTile
              icon={() => <BusinessOutlined color="primary" />}
              title="Bank Name"
              subtitle={CodTransferDetail?.bankName?.name || "N/A"}
            />
          </Grid>
        )}
        <Grid item xs={3}>
          <InformationTile
            icon={() => <PersonOutlined color="primary" />}
            title="Added User"
            subtitle={CodTransferDetail?.addedUser?.name || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <TransferWithinAStationOutlined color="primary" />}
            title="Transfer Mode"
            subtitle={CodTransferDetail?.transferMode.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <NoteOutlined color="primary" />}
            title="Notes"
            subtitle={CodTransferDetail?.notes || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Created At"
            subtitle={
              localizeDateTimeShort(CodTransferDetail?.createdAt) || "N/A"
            }
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Updated At"
            subtitle={
              localizeDateTimeShort(CodTransferDetail?.updatedAt) || "N/A"
            }
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default CodTransferBasicDetail;
